/**
 * Fonte única de navegação da Controladoria.
 */

export const DRAWER_WIDTH = 280;
export const DRAWER_WIDTH_COLLAPSED = 72;

/** @typedef {'Dashboard' | 'ShoppingCart' | 'RequestQuote' | 'Inventory' | 'Notification' | 'Receipt' | 'Car' | 'Wallet'} NavIconId */

/** @type {{ path: string, label: string, shortLabel: string, icon: NavIconId }[]} */
export const NAV_ITEMS = [
  {
    path: "/modulo/controladoria/dashboard",
    label: "Dashboard",
    shortLabel: "Dashboard",
    icon: "Dashboard",
  },
  {
    path: "/modulo/controladoria/pedidos-compra",
    label: "Pedidos de Compra",
    shortLabel: "Pedidos",
    icon: "ShoppingCart",
  },
  {
    path: "/modulo/controladoria/solicitacoes-compra",
    label: "Solicitações de Compra",
    shortLabel: "Solicitações",
    icon: "RequestQuote",
  },
  {
    path: "/modulo/controladoria/itens-pedidos-compra",
    label: "Itens de Pedidos",
    shortLabel: "Itens",
    icon: "Inventory",
  },
  {
    path: "/modulo/controladoria/nfs-pendentes",
    label: "NFs Pendentes",
    shortLabel: "NFs Pendentes",
    icon: "Notification",
  },
  {
    path: "/modulo/controladoria/consulta-nfs",
    label: "Consulta de NFs",
    shortLabel: "Consulta NFs",
    icon: "Receipt",
  },
  {
    path: "/modulo/controladoria/pedido-frota",
    label: "Pedidos de Frota",
    shortLabel: "Frota",
    icon: "Car",
  },
  {
    path: "/modulo/controladoria/fluxo-caixa",
    label: "Fluxo de Caixa",
    shortLabel: "Fluxo de Caixa",
    icon: "Wallet",
  },
];

/** @deprecated Use NAV_ITEMS — mantido para compatibilidade. */
export const NAV_GROUPS = [{ id: "menu", label: "Menu", items: NAV_ITEMS }];

export const getNavItemByPath = (pathname) => {
  const normalized = pathname.replace(/\/$/, "") || "/";
  return (
    [...NAV_ITEMS]
      .sort((a, b) => b.path.length - a.path.length)
      .find(
        (item) =>
          normalized === item.path || normalized.startsWith(`${item.path}/`)
      ) || null
  );
};
